import LoadingOvalIcon from "./loadingOval.icon";

export default function LoadingOvalCenterIcon({title}: {title?: string}) {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-3">
      <LoadingOvalIcon className="w-20 h-20" />
      {title && <span className="text-center" >{title}</span>}
    </div>
  );
}
